import { render, staticRenderFns } from "./ClubSuccess.vue?vue&type=template&id=b8e50c92&scoped=true&"
import script from "./ClubSuccess.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ClubSuccess.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ClubSuccess.vue?vue&type=style&index=0&id=b8e50c92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e50c92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8e50c92')) {
      api.createRecord('b8e50c92', component.options)
    } else {
      api.reload('b8e50c92', component.options)
    }
    module.hot.accept("./ClubSuccess.vue?vue&type=template&id=b8e50c92&scoped=true&", function () {
      api.rerender('b8e50c92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/AppointmentScreens/components/ClubSuccess.vue"
export default component.exports